module.exports = __webpack_public_path__ + "static/patterns-dot.a2735fb2.svg";